import type { IDiscountsPanel } from "@/src/discount/DiscountsPanel/DiscountsPanel";
import type { IComponent } from "@Components/Component";

import type { ILatestOffers } from "../common/LatestOffers";
import { LatestOffers } from "../common/LatestOffers";
import DiscountsPanel from "../discount/DiscountsPanel";

import * as css from "./ShoppingMallTabOffers.module.css";

export interface IShoppingMallTabOffers extends IComponent {
    hits: IDiscountsPanel;
    latestOffers: ILatestOffers;
}

export const ShoppingMallTabOffers: React.FC<IShoppingMallTabOffers> = (props) => (
    <div className={css.shoppingMallTabOffersComponent}>
        <DiscountsPanel {...props.hits} hideIfEmpty={true} titleElement="h2" />
        <LatestOffers {...props.latestOffers} className={css.categoryBottomBelt} panelTitleElement="h2" />
    </div>
);
